import React from 'react';
import PropTypes from 'prop-types';
import { rupiah } from 'utils/formatter';
import styles from './AmountToRefund.css';

class AmountToRefund extends React.Component {
  render() {
    return (
      <div className="row">
        <div className={`col-md-12 ${styles['amount-refund']}`}>
          <label className={styles['amount-refund-label']}>
            Amount to refund
          </label>
          <input
            type="text"
            className={`form-control ${styles['amount-refund-input']}`}
            placeholder={rupiah(this._calculateAmountToRefund())}
            name="refund[amount]"
            disabled="true"
          />
        </div>
      </div>
    );
  }

  _calculateAmountToRefund = () => {
    return this.props.calculateAmountToRefund();
  };
}

AmountToRefund.propTypes = {
  // calculateAmountToRefund() returns number
  calculateAmountToRefund: PropTypes.func,
};
export default AmountToRefund;
